<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="list-margin">
    <DataTable
      :value="menu"
      class="p-datatable-lg p-datatable-customers"
      dataKey="id"
      :rowHover="true"
      :resizableColumns="false"
      @sort="onSort($event)"
    >
      <template #header>
        <div class="grid m-0">
          <div class="lg:col-6 col-12 lg:text-left text-center list-header">
            Menus
          </div>
          <div class="lg:col-6 col-12 lg:text-right text-center">
            <PrimeButton
              label=" ADD "
              class="add-button mr-3"
              icon="plus-icon"
              @click="gotoCreateMenu"
            ></PrimeButton>
            <div class="p-input-icon-right">
              <i class="search-icon cursor-pointer" @click="onSearch" />
              <InputText
                placeholder="Search"
                class="search-input"
                v-model="search"
                @keyup="onSearch"
              />
            </div>
            <PrimeButton
              class="download-button ml-3"
              icon="pi pi-download"
              @click="downloadCSV"
              :disabled="menu.length == 0"
            ></PrimeButton>
          </div>
        </div>
      </template>

      <template #loading> Loading records, please wait... </template>
      <template #empty> No records found. </template>
      <Column field="name" header="Name" sortable></Column>
      <Column field="actions" header="Actions">
        <template #body="data">
          <div class="flex">
            <i
              class="pi pi-pencil cursor-pointer edit-icon"
              style="color: gray"
              @click="gotoMenuEdit(data.data.id)"
            ></i>
            <i
              class="pi pi-trash cursor-pointer delete-icon ml-1"
              style="color: #dc3545"
              @click="showDeletePopup(data.data.id)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <Paginator
      v-model:first="currentPage"
      :rows="50"
      :totalRecords="totalRecords"
      :rowsPerPageOptions="[50, 100, 150, 200]"
      template="RowsPerPageDropdown CurrentPageReport PageLinks"
      currentPageReportTemplate="{first} - {last} of {totalRecords} items"
      @page="onPage($event)"
      :class="{
        loading: loading,
      }"
    >
      <template #start> Shown per page : </template>
    </Paginator>
    <ConfirmPopup
      :show-popup="showPopup"
      @confirmYes="deleteMenu"
      @confirmNo="showPopup = false"
    ></ConfirmPopup>
  </div>
</template>
<script>
import APIService from "@/services/api-service.js";
import MenuFactory from "@/factories/menu.js";
export default {
  data() {
    return {
      loading: false,
      menu: [],
      menulist: [],
      totalRecordsStore: 0,
      currentPage: 0,
      itemsPerPage: 50,
      search: "",
      searchText: "",
      totalRecords: 0,
      sortColumn: "id",
      sortDir: "asc",
      showPopup: false,
      menuIdForDelete: "",
    };
  },

  mounted() {
    this.getMenuList();
  },
  methods: {
    downloadCSV() {
      this.$root.$globalState.loader = true;
      APIService.get(`/menu/downloadcsv`)
        .then((response) => {
          if (response && response.data && response.data.success) {
            window.open(response.data.data.file);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
        });
    },
    gotoCreateMenu() {
      this.$router.push({ name: "MenuCreate" });
    },
    gotoMenuEdit(menuId) {
      this.$router.push({
        name: "MenuEdit",
        params: { id: menuId },
      });
    },
    showDeletePopup(menuId) {
      this.menuIdForDelete = menuId;
      this.showPopup = true;
    },
    getMenuList() {
      this.$root.$globalState.loader = true;
      this.menu = [];
      APIService.get(
        `/menu/${this.currentPage}/${this.itemsPerPage}/${this.sortColumn}/${this.sortDir}/${this.searchText}`
      )
        .then((response) => {
          if (response && response.data) {
            this.totalRecords = response.data.totalrecord;
            this.menu = MenuFactory.createFromJsonArray(response.data.data);
            if (this.search.length == 0) {
              this.menulist = MenuFactory.createFromJsonArray(
                response.data.data
              );
              this.totalRecordsStore = response.data.totalrecord;
            }
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
        });
    },
    deleteMenu() {
      this.$root.$globalState.loader = true;
      APIService.delete(`/menu/delete/${this.menuIdForDelete}`)
        .then((response) => {
          if (response && response.data && response.data.success) {
            this.getMenuList();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.showPopup = false;
        });
    },
    onPage(pageData) {
      this.itemsPerPage = pageData.rows;
      this.currentPage = pageData.first;
      this.getMenuList();
    },
    onSort(sortData) {
      let sortField = sortData.sortField;
      if (sortData.sortField === "createddate") {
        sortField = "createddate";
      }
      this.sortColumn = sortField;
      this.sortDir = sortData.sortOrder === 1 ? "asc" : "dsc";
      this.currentPage = 0;

      this.getMenuList();
    },
    onSearch() {
      // this.search = this.search.trimStart().trimEnd();
      // this.currentPage = 0;
      // this.getMenuList();
      let search = this.search.trimStart().trimEnd();
      this.currentPage = 0;
      if (search.length >= 2) {
        this.searchText = this.search.trimStart().trimEnd();
        this.getMenuList();
      } else if (search.length == 0) {
        this.searchText = this.search.trimStart().trimEnd();
        this.getMenuList();
      } else if (search.length < 2) {
        this.searchText = "";
        this.menu = this.menulist;
        this.totalRecords = this.totalRecordsStore;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/datatable.scss";
</style>
